import React, { useEffect } from "react";
import { colors } from "../../constants/colors";
import { connect } from "react-redux";
// MUI Components
import { makeStyles } from "@material-ui/core/styles";

function Dropzone(props) {
  const useStyles = makeStyles({
    dropzone: {
      // height: "195px",
      height: "65%",
      width: "95%",
      display: "flex",
      alignItems: "center",
      backgroundColor: (props) => colors[props.theme].cardBkg,
      flex: "0 0 auto",
      justifyContent: "center",
      fontSize: "16px",
      border: "2px dashed rgb(187, 186, 186)",
      margin: "20px",
    },
    highlight: {
      // height: "202px",
      height: "65%",
      width: "95%",
      display: "flex",
      alignItems: "center",
      backgroundColor: (props) => colors[props.theme].primary,
      flex: "0 0 auto",
      justifyContent: "center",
      fontSize: "16px",
      border: "2px dashed rgb(187, 186, 186)",
      margin: "25px",
    },
  });

  useEffect((event) => {
    // Prevent default drag & drop behavior where browser tries to load any file dropped into it
    window.addEventListener(
      "dragover",
      function (e) {
        e = e || event;
        e.preventDefault();
      },
      false
    );

    window.addEventListener(
      "drop",
      function (e) {
        e = e || event;
        e.preventDefault();
      },
      false
    );

    return function cleanup() {};
  }, []);

  const classes = useStyles(props);

  let fileInputRef = React.createRef();
  const [highlight, setHighlight] = React.useState(false);

  function openFileDialog() {
    fileInputRef.current.click();
  }

  function handleFileUpload(event) {
    let file = event.target.files[0];
    if (!props.acceptedFormat.some((format) => file.name.endsWith(format))) {
      //Check if the uploaded file extension matches the acceptedFormats
      const message = `File must be one of ${props.acceptedFormat} format(s)`;
      props.formatError(message);
    } else {
      let reader = new FileReader();
      if (props.readFile) {
        reader.readAsDataURL(file);
        reader.onload = function () {
          props.upload(reader.result); //base64encoded string
        };
      } else {
        reader.readAsText(file); // reader.readAsText(file) calls reader.onLoad()
        props.upload(file.path);
      }
      // reader.onload = function(e) {
      //   let fileInformation = JSON.parse(e.target.result); // Convert text to JSON
      //   let data = {
      //     id: file.path,
      //     participantId: fileInformation["study"]["studyInfo"]["participantId"],
      //     protocolId: fileInformation["study"]["studyInfo"]["protocolId"],
      //     protocolName: fileInformation["study"]["studyInfo"]["protocolName"]
      //   };

      // };
    }
  }

  //TODO: Combine handleDropUpload and handleFileUpload
  function handleDropUpload(files) {
    let file = files[0];

    if (files.length > 1) {
      //Check if the uploaded file is json
      const message = "Upload a single file";
      setHighlight(false);
      props.formatError(message);
    } else if (
      !props.acceptedFormat.some((format) => file.name.endsWith(format))
    ) {
      //Check if the uploaded file is json
      const message = `File must be one of ${props.acceptedFormat} format(s)`;
      setHighlight(false);
      props.formatError(message);
    } else {
      // Can add other exeptions here
      let reader = new FileReader();
      if (props.readFile) {
        reader.readAsDataURL(file);
        reader.onload = function () {
          props.upload(reader.result); //base64encoded string
        };
      } else {
        reader.readAsText(file); // reader.readAsText(file) calls reader.onLoad()
        props.upload(file.path);
      }
    }
  }

  function onDragOver(event) {
    event.preventDefault();
    event.stopPropagation();
    event.dataTransfer.dropEffect = "copy";

    setHighlight(true);
  }

  function onDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();

    setHighlight(false);
  }

  function onDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    let dt = event.dataTransfer;
    let file = dt.files;
    handleDropUpload(file);
  }

  return (
    <div
      onClick={openFileDialog}
      onDrop={onDrop}
      onDragLeave={onDragLeave}
      onDragOver={onDragOver}
      className={highlight ? classes.highlight : classes.dropzone}
    >
      <input
        ref={fileInputRef}
        type="file"
        accept={props.acceptedFormat} //".study, .study.encrypt"
        style={{ display: "none" }}
        onChange={handleFileUpload}
      />
      <span>Drop File Here or Click to Upload </span>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    theme: state.utility.theme,
  };
};

export default connect(mapStateToProps)(Dropzone);
